import { render, staticRenderFns } from "./RegisteredComplaint.vue?vue&type=template&id=3b9122d0"
import script from "./RegisteredComplaint.vue?vue&type=script&lang=js"
export * from "./RegisteredComplaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports